import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  static targets = ["chart", "toggle"];

  get cookiesId() {
    return this.data.get("cookiesId");
  }

  connect() {
    this.portfolioOverviewChartLoaded = false;
  }

  toggleChart(e) {
    e.preventDefault();

    if (this._chartHidden()) {
      this._showChart();
    } else {
      this._hideChart();
    }
  }

  _showChart() {
    this._setChartCookie(true);
    this.chartTarget.classList.remove("tw-hidden");
    this.toggleTarget.classList.remove("text-black");
    this.toggleTarget.classList.remove("far");
    this.toggleTarget.classList.add("fas");

    if(this.portfolioOverviewChartLoaded === false){
      window.dispatchEvent(
        new CustomEvent("coingecko-portfolio-overview-chart")
      )
      this.portfolioOverviewChartLoaded = true
    }
  }

  _hideChart() {
    this._setChartCookie(false);
    this.chartTarget.classList.add("tw-hidden");
    this.toggleTarget.classList.remove("fas");
    this.toggleTarget.classList.add("far");
    this.toggleTarget.classList.add("text-black");
  }

  _chartHidden() {
    return this.chartTarget.classList.contains("tw-hidden");
  }

  _setChartCookie(value) {
    Cookies.set(`showPortfolioChart_${this.cookiesId}`, value, { expires: 365, path: "/" });
  }
}
